import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {WEEKDAYS} from '../shared/dateTimeLists';
import {
    convertDate,
    convertTimeFromHoursMinutes,
    dateIs,
    displayDateRangeString
} from '../shared/functions';
import {commonStyles} from '../shared/styles';
import {getNextScheduledDate, getScheduledReportExpirationDate} from '../shared/scheduledReportFunctions';

/**
 * A component to display a Scheduled Report summary
 *
 */
class ScheduleReportFormSummary extends Component {

    // Assemble Report Summary: Detail, Frequency, Next Runtime
    displayReportSummary = (formValues) => {
        const val = JSON.parse(JSON.stringify(formValues));
        let nowDate = new Date();

        // Assemble frequency of Report scheduling
        let reportFrequency = val.runAtType;
        let weekday = WEEKDAYS[nowDate.getDay()];
        if (val.runAtType === 'weekly') {
            weekday = WEEKDAYS.find(r => r.id === val.runAtWeekday);
            reportFrequency = (weekday) ? 'weekly on ' + weekday.name : 'weekly';
        }
        let reportTime = convertTimeFromHoursMinutes(val.runAtHour, 0);

        // Assemble Date Range
        let backType = val.backType;
        if (val.backNum === 1) {
            backType = (val.backType === 'days') ? 'day' : (val.backType === 'weeks') ? 'week' : 'month';
        }
        let reportRange = (val.dateRangeType === 'specific')
            ? displayDateRangeString(val.dateStart, val.dateEnd, false)
            : 'the Report\'s runtime to ' + val.backNum + ' ' + backType + ' back';

        // Calculate next Report runtime
        let nextDate = getNextScheduledDate(formValues, nowDate);
        let expirationDate = getScheduledReportExpirationDate(formValues);

        let nextStr = '';
        if (dateIs('today', nextDate)) {
            nextStr += 'today';
        } else if (dateIs('tomorrow', nextDate)) {
            nextStr += 'tomorrow';
        } else {
            const weekdayStr = (weekday) ? weekday.name + ', ' : '';
            nextStr += 'on ' + weekdayStr + convertDate(nextDate, 'display', false, false);
        }
        nextStr += ' at ' + reportTime;

        // Get Report Expiration
        let expStr = '';
        if (dateIs('today', expirationDate)) {
            expStr += 'today';
        } else if (dateIs('tomorrow', expirationDate)) {
            expStr += 'tomorrow';
        } else {
            const weekdayStr = (weekday) ? weekday.name + ', ' : '';
            expStr += 'on ' + weekdayStr + convertDate(expirationDate, 'display', false, false);
        }
        expStr += ' at ' + reportTime;

        return (
            <Fragment>
                <hr style={{...commonStyles.divider, ...commonStyles.mt1, ...commonStyles.mb1}}/>
                <h3>Scheduled Report Summary</h3>
                <p>
                    This Report will be scheduled to run {reportFrequency} at {reportTime}.
                </p>
                <p>
                    It will return data from {reportRange}.
                </p>
                <p>
                    This Scheduled Report will next run {nextStr}.
                </p>
                <p>
                    This Scheduled Report will expire {expStr}.
                </p>
            </Fragment>
        );
    };

    render() {
        const {
            formValues
        } = this.props;

        return (
            <Fragment>
                {this.displayReportSummary(formValues)}
            </Fragment>
        );
    }
}

ScheduleReportFormSummary.propTypes = {
    formValues: PropTypes.object
};

export default ScheduleReportFormSummary;



// WEBPACK FOOTER //
// ./src/Fuse/components/ScheduleReportFormSummary.js